import styled from 'styled-components'

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .add-new{
        max-width: 30rem;
    }
    overflow-x: scroll;
`
